module.exports = __webpack_public_path__ + "static/media/illu-protege-slip.9025dfed.png";